<div class="fx-affiliate-link-control">
  <div class="row">
    <div class="col">
      <fx-page-header title="{{'Link Control'}}"></fx-page-header>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <fx-link-control-user
        [permission]="permission"
        [originFE]="originFrontEnd"
      ></fx-link-control-user>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <fx-link-control-ib
        [permission]="permission"
        [originFE]="originFrontEnd"
      ></fx-link-control-ib>
    </div>
  </div>
</div>
